/**
 * Component Registry for Millcreek Woods Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-vantage/registry';
import { NeighborhoodSection } from './components/NeighborhoodSection';
import { PropertyOverview } from './components/PropertyOverview';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { SisterProperties } from './components/SisterProperties';
import { FloorplansList } from './components/FloorplansList';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  NeighborhoodSection,
  PropertyOverview,
  Footer,
  Header,
  Hero,
  SisterProperties,
  FloorplansList,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
